import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, CardBody, Col, Row,
} from 'reactstrap';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import { Fab } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import DeliveryRateModal from '../../AddOrUpdate/components/HubPickUpPointsDetailsModal';

const PickUpPointsDetailsView = ({ reactTableData,isNoRecordFound,dataInfo }) => {
  const [rows] = useState(reactTableData && reactTableData?.tableRowsData? reactTableData.tableRowsData:null);
  const { t } = useTranslation('common');
  const tableConfig = {
    isEditable: false,
    isSortable: true,
    isResizable: true,
    withPagination: true,
    withSearchEngine: true,
    manualPageSize: [10, 50, 100, 1000],
    placeholder: 'Search by Pick Up Point Name ...',
  };
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Add - Pick Up Point Details");
  }
  return (
    <Col md={12} lg={12}>
         <Card style={{ backgroundColor: 'white' }}>

        <CardBody>
          <Row>
            <Col md={12}>
              <h3 className="page-title">Pick Up Point Details</h3>
            </Col>
          </Row>
          <Tooltip title="Click here to add new details">
            <Fab size="large" color="primary" aria-label="add" style={{ float: "right", backgroundColor: "#32CA73", color: "white" }} onClick={() => Add()}>
              <AddIcon />
            </Fab>
          </Tooltip>
          {!isNoRecordFound &&  rows?
          <ReactTableBase
            name={t('instution_type.view.name_map')}
            key={'searchable'}
            columns={reactTableData.tableHeaderData}
            data={rows}         
            tableConfig={tableConfig}
          />:<div></div>
}
          {viewDetailPopup &&
            <DeliveryRateModal
              modalShow={viewDetailPopup}
              setModalShow={setViewDetailPopup}
              dataInfo={dataInfo}
              isTitle={isTitle}         />}
        </CardBody>
      </Card>
    </Col>
  );
};

PickUpPointsDetailsView.propTypes = {
  reactTableData: PropTypes.shape({
    tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string,
      name: PropTypes.string,
    })),
    tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
  }).isRequired,
};

export default PickUpPointsDetailsView;
